import { render, staticRenderFns } from "./tactics.vue?vue&type=template&id=7fe7192e&scoped=true"
import script from "./tactics.vue?vue&type=script&lang=js"
export * from "./tactics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe7192e",
  null
  
)

export default component.exports